export class VaultProviderAttributesInput {
    'cloudProvider';
    'aws';
    'azure';
    'gcp';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "cloudProvider",
            "baseName": "cloudProvider",
            "type": "Provider",
            "format": ""
        },
        {
            "name": "aws",
            "baseName": "aws",
            "type": "AwsVaultConfigInput",
            "format": ""
        },
        {
            "name": "azure",
            "baseName": "azure",
            "type": "AzureVaultConfigInput",
            "format": ""
        },
        {
            "name": "gcp",
            "baseName": "gcp",
            "type": "GcpVaultConfigInput",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return VaultProviderAttributesInput.attributeTypeMap;
    }
    constructor() {
    }
}
